export default __webpack_public_path__ + "static/media/lADPGoGu9dKxp4LNBQDNA8A_960_1280.8a4c6495.jpeg";